import { CompositionEditor } from '@/app/layout/CompositionEditor'
import { TopBar } from '@/app/layout/TopBar'
import { ToolPanel } from '@/app/layout/ToolPanel'
import { BottomSheet } from '@/ui/BottomSheet'

export function MobileLayout({ onChooseImage }: { onChooseImage: () => void }) {
  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      <TopBar mobile onChooseImage={onChooseImage} />
      <main className="relative min-h-0 flex-1 overflow-hidden">
        <CompositionEditor />
        <BottomSheet>
          <div className="flex h-full min-h-0 flex-col">
            <div className="min-h-0 flex-1"><ToolPanel /></div>
          </div>
        </BottomSheet>
      </main>
    </div>
  )
}
